const styles = {
  global: {
    body: {
      fontSize: "1rem",
      color: "gray.800",
      bg: "none",
    },
    "*, *::before, &::after": {
      wordWrap: null,
    },
    ".chakra-button:hover svg": {
      path: {
        transition: "all 250ms",
        stroke: "white",
      },
    },
  },
};

export default styles;
